export enum ApolloContextKey {
  CUSTOM_OPERATION_NAME = 'custom_operation_name',
}
